// Shared constants and helpers for menu categorization (used by RestaurantCuisine and MenuRefreshPanel)

export const CATEGORY_CONFIG = [
  {
    key: "GUARANTEED_VEGAN",
    color: "#2E7D32",
    label: "Verified Vegan",
    prefix: "\u2605",
    defaultCategory: "vegan",
  },
  {
    key: "PROBABLY_VEGAN",
    color: "#4CAF50",
    label: "Likely Vegan",
    prefix: "\u2713",
    defaultCategory: "maybeVegan",
  },
  {
    key: "MAYBE_VEGAN",
    color: "#FFC107",
    label: "Maybe Vegan",
    prefix: "?",
    defaultCategory: "maybeVegan",
  },
  {
    key: "PROBABLY_NOT_VEGAN",
    color: "#d32f2f",
    label: "Likely NOT Vegan",
    prefix: "\u2717",
    defaultCategory: "maybeVegan",
  },
];

// Section is a subdocument: {name: string, order: number} or null
// Helper to extract section name (handles both subdocument and legacy string format)
export const getSectionName = (section) => {
  if (!section) return null;
  if (typeof section === "string") return section;
  return section.name || null;
};

export const getSectionOrder = (section) => {
  if (!section) return null;
  if (typeof section === "string") return null;
  return section.order;
};

export const groupItemsBySection = (items) => {
  const grouped = {};
  const sectionOrderMap = {};
  items.forEach((item) => {
    const sectionName = getSectionName(item.section);
    const sectionOrder = getSectionOrder(item.section);
    if (!grouped[sectionName]) {
      grouped[sectionName] = [];
      sectionOrderMap[sectionName] = sectionOrder ?? Infinity;
    } else if (sectionOrder != null && sectionOrder < sectionOrderMap[sectionName]) {
      sectionOrderMap[sectionName] = sectionOrder;
    }
    grouped[sectionName].push(item);
  });
  return { grouped, sectionOrderMap };
};

export const sortSectionKeys = (keys, sectionOrderMap = {}) => {
  return keys.sort((a, b) => {
    if (a === null && b === null) return 0;
    if (a === null) return 1;
    if (b === null) return -1;
    const orderA = sectionOrderMap[a] ?? Infinity;
    const orderB = sectionOrderMap[b] ?? Infinity;
    if (orderA !== orderB) return orderA - orderB;
    return a.localeCompare(b);
  });
};
